import * as React from "react"

const SvgBarChart = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.62 19.784a.97.97 0 0 0 .713.287.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.713v-12a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712v12q0 .425.288.713Zm11.38.287a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-13q0-.424.288-.712A.97.97 0 0 1 20 5.07q.424 0 .712.288.288.289.288.712v13a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287Zm-5.333 0a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-8a.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288q.424 0 .712.288t.288.712v8a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287M4 20.071a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 19.07v-7q0-.424.288-.712A.97.97 0 0 1 4 11.07a.97.97 0 0 1 .713.288q.287.289.287.712v7a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287Z" />
  </svg>
)
export default SvgBarChart
